import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-warning",
  templateUrl: "./med-icon-warning.component.html",
})
export class MedIconWarningComponent extends SvgMixinComponent {}
